//Own
import { API_V3 } from 'constants/env-variables';
import { UserLogged } from 'state/auth/types';

async function authUser(tokenEmail: string): Promise<UserLogged> {
  const url = `${API_V3}/business-markers/auth/${tokenEmail}`;

  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }).then(response => response.json() as Promise<RawResponse>);

  if (!response.success || !response.userLogged) {
    throw response;
  }

  return response.userLogged;
}

export default authUser;

export interface RawResponse {
  success: boolean;
  userLogged?: UserLogged;
}
